import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { EditableDBItemV3, ModuleFE_Dialog, ToastBuilder, TS_Dialog } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { ModuleFE_Resource } from '@app/hcs-frontend';
import './ResourcesManager_Dialogs.scss';
import { _keys, capitalizeFirstLetter } from '@nu-art/ts-common';
import { ResourceItem_EditorRenderer } from '../editors/Editor-renderers/ResourceItem_EditorRenderer.js';
export class Dialog_CreateNewResource extends TS_Dialog {
    static defaultProps = {
        dialogId: 'create-new-order-dialog',
    };
    static show(onCompleted) {
        ModuleFE_Dialog.show({
            content: _jsx(Dialog_CreateNewResource, { className: 'dialog', onCompleted: onCompleted }),
            closeOverlayOnClick: () => false
        });
    }
    // ######################## Life Cycle ########################sc
    deriveStateFromProps(nextProps, state) {
        state.dialogIsBusy = false;
        state.resourceItem = {};
        return state;
    }
    // ######################## Logic ########################
    closeDialog = () => {
        if (!this.state.dialogIsBusy)
            ModuleFE_Dialog.close();
    };
    execute = async () => {
        this.logWarning(this.state.resourceItem);
        const newResource = new EditableDBItemV3(this.state.resourceItem, ModuleFE_Resource, (e) => {
            throw e;
        });
        this.setState({ dialogIsBusy: true });
        try {
            await newResource.save();
            ModuleFE_Dialog.close();
        }
        catch (err) {
            this.setState({ dialogIsBusy: false });
            new ToastBuilder().setContent(_jsx("div", { children: _jsx("span", { className: 'toast-text', children: `Missing Fields: ${_keys(err.result).map((item) => capitalizeFirstLetter(item)).join(', ')}` }) })).setDuration(4000).show();
            this.logError(err);
        }
    };
    // ######################## Render ########################
    renderHeader = () => {
        return _jsxs(_Fragment, { children: [_jsx("span", { className: "header__title", children: "Create New Resource" }), _jsx("div", { className: 'header__buttons', children: _jsx(ICONS.x.component, { className: "exit_icon", onClick: this.closeDialog }) })] });
    };
    renderBody = () => {
        return _jsx(ResourceItem_EditorRenderer, { editable: new EditableDBItemV3(this.state.resourceItem, ModuleFE_Resource), isInEditMode: true });
    };
    buttons = () => {
        return {
            right: [
                { content: 'Cancel', className: 'cancel-button', onClick: this.closeDialog },
                {
                    content: 'Save Resource',
                    onClick: this.execute,
                    className: 'desired-action-button',
                    associatedKeys: ['Enter'],
                }
            ]
        };
    };
}
